import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { observer } from "mobx-react-lite";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter-list.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { UIStateStoreContext } from "../../stores/uiStateStore";
/**
 * Renders the toggle filters button in the mobile view.
 */
export const ToggleFiltersButton = observer(() => {
    const intl = useIntl();
    const state = useContext(UIStateStoreContext);
    return state.isSidebarToggled() ? (_jsx("button", { type: "button", className: "sui-layout-sidebar-toggle close-sidebar", onClick: () => state.toggleSidebar(), "data-testid": "closeFilters", title: intl.formatMessage({ id: "icon.closeFilters.title" }), children: _jsx(CloseIcon, {}) })) : (_jsxs("button", { type: "button", className: "sui-layout-sidebar-toggle", onClick: () => state.toggleSidebar(), "data-testid": "openFilters", title: intl.formatMessage({ id: "filterSearchResults" }), children: [_jsx(FilterIcon, {}), _jsx(FormattedMessage, { id: "filterSearchResults" })] }));
});
